import { useTranslation } from "react-i18next";
import { ContractPaymentModel, ScheduleRecentBill } from "src/api/contract/contract-types";
import { DocumentProofRequest, PaymentInfo, ReceiptBundle } from "./types";
import { CreditCardDetails, VirtualAccountDetails } from "./paymentDetails";

// 결제 정보 표시 컴포넌트의 props 인터페이스
interface ServiceTypePaymentPriceInfoProps {
  recentBill: ScheduleRecentBill; // 최근 결제 정보
  checkExpireFiltered: PaymentInfo[]; // 만료되지 않은 결제 정보 목록
  receiptBundle?: ReceiptBundle; // 영수증 번들 정보
  documentProofRequest: DocumentProofRequest; // 증빙서류 요청 정보
  onCopyAccount: (account: string) => void; // 계좌번호 복사 핸들러
  contractCancelList: Array<any>; // 결제 취소 목록
}

// 결제 정보를 표시하는 컴포넌트
const ServiceTypePaymentPriceInfo = ({
  recentBill,
  checkExpireFiltered,
  receiptBundle,
  documentProofRequest,
  onCopyAccount,
  contractCancelList,
}: ServiceTypePaymentPriceInfoProps) => {
  const { t } = useTranslation("contract");
  // 현재 결제 정보 설정
  let payment: any = {};
  if (checkExpireFiltered.length > 0) {
    payment = checkExpireFiltered[0];
  } else {
    payment = recentBill;
  }
  return (
    <div className="base-section-layout__wrap mb30 pb0">
      <div className="base-section-layout__title-wrap">
        <h2>{t("detail.paymentInformation")}</h2>
      </div>

      {/* 신용카드 결제 정보 표시 */}
      {payment.pgcode === "creditcard" && (
        <CreditCardDetails
          payment={payment}
          totalPaymentAmount={payment.totalAmount}
          receiptBundle={receiptBundle}
          contractCancelList={contractCancelList}
        />
      )}

      {/* 가상계좌 결제 정보 표시 */}
      {payment.pgcode === "virtualaccount" && (
        <VirtualAccountDetails
          payment={payment}
          documentProofRequest={documentProofRequest}
          billPayStatus={recentBill.billPayStatus}
          receiptBundle={receiptBundle}
          contractCancelList={contractCancelList}
          onCopyAccount={onCopyAccount}
        />
      )}
    </div>
  );
};

export default ServiceTypePaymentPriceInfo;
